<template>
  <div :class="[`col-md-12`]">
    <label>{{ label }}</label>

    <div v-for="(item, itemIndex) in itemsCollection" :key="`item-${uniqueKey}-${itemIndex}`" class="collection-item py-4 px-5 mb-3">
      <!-- groups -->
      <template v-for="(group, groupIndex) in item">
        <div class="form-group report-group row" :key="`item-group-${uniqueKey}-${groupIndex}-${fieldKey}`">
          <!-- fields -->
          <template v-for="(field, fieldIndex) in group.fields">
            <component
              :is="`report-${field.type}`"
              v-bind="field"
              v-model="field.value"
              :key="`item-field-${uniqueKey}-${groupIndex}-${fieldKey}-${fieldIndex}`"
              class="report-field"
              @input="emitUpdateItems"
            ></component>
          </template>
          <!-- end fields -->
        </div>
      </template>
      <!-- end groups -->
    </div>

    <!-- <div class="text-primary font-weight-bold" style="cursor: pointer" @click="addItem">+ Aggiungi {{ itemName }}</div> -->
  </div>
</template>

<script>
import ReportDeleteModal from "@/Pages/Admin/Properties/Report/Partials/ReportDeleteModal";
import ReportFiles from "@/Pages/Admin/Properties/Report/Partials/ReportFiles";
import ReportFlag from "@/Pages/Admin/Properties/Report/Partials/ReportFlag";
import ReportFormModal from "@/Pages/Admin/Properties/Report/Partials/ReportFormModal";
import ReportIndexTable from "@/Pages/Admin/Properties/Report/Partials/ReportIndexTable";
import ReportNumber from "@/Pages/Admin/Properties/Report/Partials/ReportNumber";
import ReportSelect from "@/Pages/Admin/Properties/Report/Partials/ReportSelect";
import ReportText from "@/Pages/Admin/Properties/Report/Partials/ReportText";
import ReportTextarea from "@/Pages/Admin/Properties/Report/Partials/ReportTextarea";

export default {
  components: {
    ReportDeleteModal,
    ReportFiles,
    ReportFlag,
    ReportFormModal,
    ReportIndexTable,
    ReportNumber,
    ReportSelect,
    ReportText,
    ReportTextarea,
  },

  props: ["uniqueKey", "fieldKey", "label", "itemName", "form", "items"],

  data() {
    return {
      itemsCollection: [],
    };
  },

  watch: {
    items: {
      immediate: true,
      handler: function () {
        this.initItemsCollection();
      },
    },
  },

  methods: {
    emitUpdateItems() {
      let arr = _.cloneDeep(this.itemsCollection);
      if (this.checkFormEmpty()) arr.pop();
      this.$emit("update:items", arr);
    },
    initItemsCollection() {
      this.itemsCollection = _.cloneDeep(this.items);
      this.itemsCollection.push(_.cloneDeep(this.form));
    },
    checkFormEmpty() {
      let empty = true;

      this.itemsCollection[this.itemsCollection.length - 1].forEach((g) =>
        g.fields.forEach((f) => {
          if (f.value != null) empty = false;
        })
      );

      return empty;
    },
    addItem() {
      this.itemsCollection.push(_.cloneDeep(this.form));
    },
    removeItem(itemIndex) {
      this.itemsCollection.splice(itemIndex, 1);
      this.emitUpdateItems();
    },
  },
};
</script>

<style lang="scss" scoped>
.collection-item {
  background-color: #f7f7f7;
  border-radius: 6px;

  .report-group {
    margin-bottom: 1.5rem !important;
  }
}
</style>